// UI sound helpers: thin, failure-tolerant wrappers around the audio singleton
// (which may still be a stub while modules are being written).

import { audio } from '../audio';
import type { SfxId } from '../core/types';

let lastHover = 0;

/** Play a sound effect; never throws. */
export function sfx(id: SfxId, opts?: { volume?: number; pitch?: number; pan?: number }): void {
  try {
    audio.play(id, opts);
  } catch {
    // Audio is optional.
  }
}

/** Focus / hover tick, throttled so sweeping the mouse over a list does not machine-gun. */
export function sfxHover(): void {
  const now = performance.now();
  if (now - lastHover < 45) return;
  lastHover = now;
  sfx('ui_hover', { volume: 0.7 });
}

/** Resume the AudioContext after a user gesture (safe to call repeatedly). */
export function unlockAudio(): void {
  try {
    audio.unlock();
  } catch {
    // ignore
  }
}

/** Switch music track; never throws. */
export function music(track: Parameters<typeof audio.music>[0], fadeMs = 900): void {
  try {
    audio.music(track, { fadeMs });
  } catch {
    // ignore
  }
}
